import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { safeFrom } from './Login';

function Register() {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [invite, setInvite] = useState('');
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();
  const { search } = useLocation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await register(username, email, password, invite);
      navigate(safeFrom(search));
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{ maxWidth: '400px', margin: '80px auto', padding: '0 20px' }}>
      <h1>Worldview</h1>
      <h2>Create account</h2>
      {error && <div style={{ color: 'var(--wv-neg)', marginBottom: '12px' }}>{error}</div>}
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '12px' }}>
          <label style={{ display: 'block', marginBottom: '4px' }}>Username</label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }}
            autoFocus
            autoComplete="username"
          />
        </div>
        <div style={{ marginBottom: '12px' }}>
          <label style={{ display: 'block', marginBottom: '4px' }}>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }}
            autoComplete="email"
          />
        </div>
        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '4px' }}>Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }}
            autoComplete="new-password"
          />
          <div style={{ fontSize: '12px', color: 'var(--wv-muted)', marginTop: '4px' }}>Minimum 8 characters</div>
        </div>
        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '4px' }}>Invite code</label>
          <input
            type="text"
            value={invite}
            onChange={(e) => setInvite(e.target.value)}
            style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }}
            autoComplete="off"
          />
          <div style={{ fontSize: '12px', color: 'var(--wv-muted)', marginTop: '4px' }}>
            Only needed if this server is invite-only.
          </div>
        </div>
        <button type="submit" disabled={!username || !email || !password || submitting} style={{ width: '100%', padding: '10px' }}>
          {submitting ? 'Creating account...' : 'Create account'}
        </button>
      </form>
      <p style={{ marginTop: '16px', fontSize: '14px' }}>
        Already have an account? <Link to={`/login${search}`}>Log in</Link>
      </p>
    </div>
  );
}

export default Register;
